// filepath: apps/web/src/features/admin/templates/registry/TemplateRegistryRoute.tsx
//
// FR-UI-ADM-11 AC-6 -- route shell for the template registry
// admin editor.
//
// URL: /admin/templates/registry
//
// Defense-in-depth: the route enforces the staging-only gate
// at the SPA layer. The server rejects production writes with
// HTTP 403 ENV_PRODUCTION on POST /api/templates/{template_id}/
// install (the browse verb GET /api/templates/registry is
// read-only and accessible from both environments, but the
// install action is staging-only).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { TemplateRegistryPage } from "./TemplateRegistryPage";

interface TemplateRegistryRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function TemplateRegistryRoute({
  environmentKind,
}: TemplateRegistryRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <TemplateRegistryPage environmentKind={environmentKind} />;
}
